import React, { useState } from 'react';
import { ROLES, PHASES } from '../data/roles';
import { SECTIONS } from '../data/sections';
import { getSectionProgress, getPhaseProgress, getOverallProgress, getPctColor } from '../utils/progress';
import { exportProgressCSV } from '../utils/exportUtils';
import WizardZone from './WizardZone';
import './DashScreen.css';

export default function DashScreen({ state, onOpenSection, onWizSelect, onWizBack, onWizReset, showTree, onToggleTree }) {
  const role    = ROLES[state.role];
  const overall = getOverallProgress(state.progress, state.role);
  const pc      = getPctColor(overall.pct, role.color);
  const handleExport = () => exportProgressCSV(state, state.role);

  return (
    <div className="page-content">
      {/* Header */}
      <div className="dash-header">
        <div>
          <div className="dash-title">{role.label} — Process Dashboard</div>
          <div className="dash-sub">Track your progress across all SDLC phases</div>
        </div>
        <div className="dash-header-actions">
          <div className="dash-role-badge" style={{ background: role.light, color: role.color }}>
            <i className={`ti ${role.icon}`} style={{ fontSize: 13 }} aria-hidden="true" />
            {role.label}
          </div>

          <button className="btn btn-sm btn-export" onClick={handleExport} title="Export progress as CSV">
            <i className="ti ti-download" aria-hidden="true" />
            <span>Export</span>
          </button>
        </div>
      </div>

      {/* Wizard */}
      <WizardZone
        state={state}
        onWizSelect={onWizSelect}
        onWizBack={onWizBack}
        onWizReset={onWizReset}
        onOpenSection={onOpenSection}
      />

      {/* Stats */}
      <div className="stats-row">
        <div className="stat-box">
          <div className="stat-num" style={{ color: pc }}>{overall.pct}%</div>
          <div className="stat-lbl">Overall progress</div>
        </div>
        <div className="stat-box">
          <div className="stat-num" style={{ color: '#375623' }}>{overall.done}</div>
          <div className="stat-lbl">Steps done</div>
        </div>
        <div className="stat-box">
          <div className="stat-num" style={{ color: '#854F0B' }}>{overall.inProg}</div>
          <div className="stat-lbl">In progress</div>
        </div>
        <div className="stat-box">
          <div className="stat-num" style={{ color: '#A32D2D' }}>{overall.blocked}</div>
          <div className="stat-lbl">Blocked</div>
        </div>
      </div>

      {/* Phase cards */}
      {PHASES.map(ph => {
        const relevant = ph.keys.filter(k => role.sections.includes(k));
        if (!relevant.length) return null;
        const pp = getPhaseProgress(state.progress, ph.keys, role.sections);
        return (
          <PhaseCard
            key={ph.code}
            phase={ph}
            relevant={relevant}
            progress={state.progress}
            phaseProgress={pp}
            roleColor={role.color}
            roleLight={role.light}
            onOpenSection={onOpenSection}
          />
        );
      })}
    </div>
  );
}

function PhaseCard({ phase, relevant, progress, phaseProgress, roleColor, roleLight, onOpenSection }) {
  const [open, setOpen] = useState(true);
  const pc = getPctColor(phaseProgress.pct, roleColor);

  return (
    <div className="phase-card">
      <div className="phase-head" onClick={() => setOpen(o => !o)}>
        <div className="phase-head-left">
          <span className="phase-code" style={{ background: roleLight, color: roleColor }}>{phase.code}</span>
          <i className={`ti ${phase.icon}`} style={{ fontSize: 13, color: roleColor }} aria-hidden="true" />
          <span className="phase-title">{phase.title}</span>
        </div>
        <div className="phase-head-right">
          <span className="phase-pct" style={{ color: pc }}>{phaseProgress.pct}%</span>
          <i className="ti ti-chevron-down"
            style={{ fontSize: 13, color: '#9E9E9E', transform: open ? 'rotate(180deg)' : '', transition: 'transform 0.2s' }}
            aria-hidden="true" />
        </div>
      </div>

      <div className="pbar" style={{ margin: '0 14px 8px' }}>
        <div className="pfill" style={{ width: `${phaseProgress.pct}%`, background: pc }} />
      </div>

      {open && (
        <div className="sec-list">
          {relevant.map(k => {
            const sp  = getSectionProgress(progress, k);
            const spc = getPctColor(sp.pct, roleColor);
            return (
              <div key={k} className="sec-row" onClick={() => onOpenSection(k)}>
                <div className="sec-row-left">
                  <span className="sec-badge" style={{ background: roleLight, color: roleColor }}>{k}</span>
                  <span className="sec-title">{SECTIONS[k]?.title}</span>
                </div>
                <div className="sec-row-right">
                  <span className="sec-pct">{sp.done}/{sp.total}</span>
                  <div className="mbar">
                    <div className="mfill" style={{ width: `${sp.pct}%`, background: spc }} />
                  </div>
                  <i className="ti ti-chevron-right" style={{ fontSize: 12, color: '#9E9E9E' }} aria-hidden="true" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
